var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassPathsLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 19C0 17.0803 0.790176 15.2393 2.1967 13.8819C3.60322 12.5245 5.51088 11.7619 7.5 11.7619C9.48912 11.7619 11.3968 12.5245 12.8033 13.8819C14.2098 15.2393 15 17.0803 15 19H0ZM7.5 10.8571C4.39219 10.8571 1.875 8.42786 1.875 5.42857C1.875 2.42929 4.39219 0 7.5 0C10.6078 0 13.125 2.42929 13.125 5.42857C13.125 8.42786 10.6078 10.8571 7.5 10.8571Z",
    fill: "#6C5DD3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassPathsLogo1);
export default __webpack_public_path__ + "static/media/classPathsLogo1.7f377c26b9baa02500327496b01c3a3a.svg";
export { ForwardRef as ReactComponent };